export const userActionTypes = {
  SELECT_DATA: "SELECT_DATA",
  TOGGLE_ACTIVE_MENU: "TOGGLE_ACTIVE_MENU",
  TOGGLE_HIDDEN_ITEM: "TOGGLE_HIDDEN_ITEM",
  TOGGLE_HIDDEN: "TOGGLE_HIDDEN",
};
